import { useContext, useEffect, useState } from "react"
import { Form, Formik } from "formik"
import { toast } from "react-toastify"
import { FiCheck } from "react-icons/fi"
import { Button, Select } from "../../../../../components/Form"
import { api, authHeaders } from "../../../../../services/api"
import { GlobalContext } from "../../../../../contexts/GlobalContext"
import formUtils from '../../../../../util/form'
import { Container } from './styles'

export function PainelProjetoRepresentante({ projeto, onChangeAvaliadorTRL }) {
	const { checkException } = useContext(GlobalContext)
	
	const [avaliadores, setAvaliadores] = useState([])

	const avaliadorTRLAtual = projeto?.pessoas.find(p => p.condicao.toLowerCase() === 'avaliador trl')

	async function loadAvaliadores() {
		const response = await api.get('instituicao/avaliadores', authHeaders())

		console.log(projeto.pessoas)

		setAvaliadores(response.filter(item => !projeto.pessoas.some(p => p.id === item.pessoa.id)).map(item => item.pessoa))
	}

	async function handleSubmit(values) {
		try {
			values = formUtils.extractFormValues(values)

			await api.patch(`projeto/${projeto.id}/add/${values.avaliador}`, {
				pessoa_funcao: 3
			}, authHeaders())

			toast.success('Avaliador TRL definido com sucesso.')

			onChangeAvaliadorTRL()
		} catch(e) {
			checkException(e)
		}
	}

	useEffect(() => {
		if(projeto) {
			loadAvaliadores()
		}
	}, [projeto])

	if(!projeto) {
		return null
	}

	return (
		<Container>
			<h1>{projeto.nome}</h1>

			<div className="mt-4 flex flex-col gap-6">
				<div className="flex flex-col gap-x-8 gap-y-3 mt-6 w-full">
					<div className="flex gap-2">
						<span className="font-semibold">Área de atuação:</span>
						<span className="group-hover:border-b group-hover:border-dashed">
							{projeto.area_atuacao}
						</span>
					</div>

					<div className="flex gap-2">
						<span className="font-semibold">Detalhes:</span>
						<span className="group-hover:border-b group-hover:border-dashed">
							{projeto.descricao}
						</span>
					</div>

					<div className="flex gap-2">
						<span className="font-semibold">Objetivo:</span>
						<span className="group-hover:border-b group-hover:border-dashed">
							{projeto.objetivo}
						</span>
					</div>
				</div>

				<div>
					<h2 style={{ fontSize: 17 }} className="font-semibold">Definição de avaliador TRL</h2>

					{avaliadorTRLAtual && (
						<div className="flex gap-1 mt-3">
							<span className="font-semibold">Avaliador TRL atual:</span>
							<span>{avaliadorTRLAtual.nome}</span>
							
							{!avaliadorTRLAtual.aceite && (
								<span className="text-yellow-300">(aceitação pendente)</span>
							)}
						</div>
					)}

					<Formik
						onSubmit={handleSubmit}
						initialValues={{
							avaliador: null
						}}
					>
						{({ setFieldValue, values }) => (
							<Form>
								<Container>
									<Select 
										name="avaliador"
										label="Novo avaliador"
										options={avaliadores.map(avaliador => ({
											label: avaliador.nome,
											value: avaliador.id
										}))}
										onChange={(selected, meta) => {
											setFieldValue(meta.name, selected)
										}}
									/>

									{values.avaliador && (
										<Button type="submit" className="white w-48">
											Confirmar alteração
											<FiCheck size={16} />
										</Button>
									)}
								</Container>
							</Form>
						)}
					</Formik>
				</div>
			</div>
		</Container>
	)
}


